import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json" with { type: "json" };
import zhTW from "./zh-TW.json" with { type: "json" };

export function initI18n(defaultLocale: "en" | "zh-TW" = "en"): void {
  if (i18n.isInitialized) return;
  void i18n.use(initReactI18next).init({
    lng: defaultLocale,
    fallbackLng: "en",
    resources: {
      en: { ui: en },
      "zh-TW": { ui: zhTW },
    },
    ns: ["ui"],
    defaultNS: "ui",
    interpolation: { escapeValue: false },
  });
}

export { default as i18n } from "i18next";
